<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <v-row>
          <v-col cols="12">
            <v-btn :disabled="loading" block color="error" @click="$store.commit('open_create_setting_dialog')">
              ساخت تنظیمات جدید
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" v-for="(setting,index) in settings" :key="setting.id">
            <SettingEditable v-model="settings[index]"/>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <CreateSettingDialog/>
    <CreateFieldDialog/>
    <EditSelectDialog/>
    <EditTextDialog/>
    <EditTagDialog />
  </v-container>
</template>

<script>
import SettingEditable from "./SettingComponents/SettingEditable";
import {mapState} from "vuex";
import CreateFieldDialog from "./SettingComponents/CreateFieldDialog";
import EditSelectDialog from "./SettingComponents/FieldEditDialogs/EditSelectDialog";
import CreateSettingDialog from "./SettingComponents/CreateSettingDialog";
import EditTextDialog from "./SettingComponents/FieldEditDialogs/EditTextDialog";
import EditTagDialog from "./SettingComponents/FieldEditDialogs/EditTagDialog";

export default {
  name: "CreateSetting",
  components: {EditTagDialog, EditTextDialog, CreateSettingDialog, EditSelectDialog, CreateFieldDialog, SettingEditable},
  computed: {
    ...mapState({
      loading: state => state.Admin.settings.loading,
      settings: state => state.Admin.settings.list
    }),
  },
  mounted() {
    this.$store.dispatch('get_all_settings')
  }
}
</script>

<style scoped>

</style>
